<template>
  <app-date-input
    :label="label"
    :name="name"
    class="placeholder-wrapper"
    :class="{'has-content': (Boolean(internalValue) || Boolean(suggestedLocalDate))}"
    v-model="internalValue"
    @input="$emit('input', internalValue)"
    @suggestedLocalDateChanged="suggestedLocalDate = $event"
    >
  </app-date-input>
</template>
<script>
  import AppDateInput from '@atoms/DateInput'

  export default {
    components: {
      AppDateInput
    },
    props: {
      label: String,
      name: String,
      value: String
    },
    data() {
      return {
        internalValue: this.value,
        suggestedLocalDate: ''
      }
    }
  }
</script>
